import React from 'react';
import ContactForm from '../../components/ContactForm';
import { Mail, MapPin, Lightbulb } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <div className="pt-10 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          
          {/* Info Side */}
          <div className="space-y-10 animate-slide-left">
            <div>
              <h1 className="text-4xl md:text-6xl font-extrabold mb-6 text-white tracking-tight leading-tight">
                Automatiza tu <br/> 
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400">negocio.</span>
                <span className="block text-mira-accent drop-shadow-[0_0_15px_rgba(26,140,255,0.4)] mt-2">Empecemos tu proyecto.</span>
              </h1>
              <p className="text-lg text-gray-400 font-medium leading-relaxed max-w-lg">
                Te ayudamos a ahorrar tiempo, mejorar tu atención y dejar de perder clientes. Cuéntanos qué necesitas automatizar.
              </p>
            </div>

            <div className="space-y-8">
              <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 bg-mira-surface rounded-lg border border-mira-border flex items-center justify-center shrink-0 group-hover:border-mira-accent transition-colors shadow-lg">
                  <Mail className="w-6 h-6 text-mira-accent" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white group-hover:text-mira-accent transition-colors">Correo Electrónico</h3>
                  <p className="text-gray-400">diegorioia25@gmail.com</p>
                  <p className="text-xs text-gray-500 mt-1">Respuesta en menos de 24h</p>
                </div>
              </div>

               <div className="flex items-start space-x-4 group">
                <div className="w-12 h-12 bg-mira-surface rounded-lg border border-mira-border flex items-center justify-center shrink-0 group-hover:border-mira-accent transition-colors shadow-lg">
                  <MapPin className="w-6 h-6 text-mira-accent" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white group-hover:text-mira-accent transition-colors">Ubicación</h3>
                  <p className="text-gray-400">Puebla, México</p>
                  <p className="text-xs text-gray-500 mt-1 font-semibold text-mira-accent">Proyectos en México y Latinoamérica</p>
                </div>
              </div>
            </div>
            
            <div className="p-6 bg-amber-500/10 border border-amber-500/20 rounded-xl shadow-[0_0_15px_rgba(245,158,11,0.1)] hover:border-amber-500/40 transition-colors">
                <div className="flex gap-3">
                    <Lightbulb className="w-6 h-6 text-amber-400 shrink-0" />
                    <div>
                        <p className="text-sm text-amber-100 font-bold mb-1">
                            Tip para una cotización precisa:
                        </p>
                        <p className="text-sm text-amber-200/80 leading-relaxed">
                            Describe tu proceso actual y qué problema quieres resolver. Entre más detalles compartas, más rápido te daremos una propuesta precisa.
                        </p>
                    </div>
                </div>
            </div>
          </div>

          {/* Form Side */}
          <div className="animate-fade-up">
            <ContactForm />
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactPage;